import general from '@/navigation/vertical/general'
import procurements from '@/navigation/vertical/procurements'
import userManagement from '@/navigation/vertical/user-management'
import budgets from '@/navigation/vertical/budgets'

export default [
  ...general,
  ...procurements,
  ...userManagement,
  ...budgets,
]
